export default {
  biodata: (param) => `profile?${buildQuery(param)}`,
  editbiodata: "profile/update",
  updateNested: "profile/updateNested",
};

function buildQuery(param) {
  const query = new URLSearchParams(param);
  return query.toString();
}
